export const postAccessInitialState = {
	access: null,
	error: null,
	errorShow: false,
	loading: false,
};
